export type OrderObservationMessages = {
  //Titles
  orderObservationTitle: string;

  //Placeholder
  orderComments1Placeholder: string;
};

export const ORDER_OBSERVATION_MESSAGES: OrderObservationMessages = {
  //Titles
  orderObservationTitle: "Observações",

  //Placeholder
  orderComments1Placeholder: "Observação para o pedido",
};
